import { useEffect, useState } from "react";
import { getMapProvider, isOSMAvailable } from "../utils/mapUtils";

/**
 * 지도 제공자(Kakao 또는 OSM) 선택 훅
 * 
 * 줌 레벨 기반 전환:
 * - 카카오맵 레벨 12 이상(축소) → OSM으로 전환 (더 축소 가능)
 * - 카카오맵 레벨 10 이하(확대) + 한국 → 카카오맵으로 복귀
 * 
 * 조건:
 * - user.area === "00000" && user.grade === 2
 *   → 한국 영역 + 확대: Kakao, 해외 영역 또는 축소: OSM
 * - OSM 허용 URL → OSM
 * - 그 외 → 카카오맵
 */
export const useMapProvider = (centerLat: number, centerLng: number, level?: number) => {
  const [mapProvider, setMapProvider] = useState<"kakao" | "osm">("kakao");
  const osmAvailable = isOSMAvailable();

  useEffect(() => {
    if (!osmAvailable) {
      // OSM 사용 불가능하면 항상 카카오맵
      setMapProvider("kakao");
      return;
    }

    // OSM 사용 가능한 경우, 현재 좌표와 줌 레벨로 판단
    const provider = getMapProvider(centerLat, centerLng, level);
    setMapProvider(provider);
  }, [centerLat, centerLng, level, osmAvailable]);

  return {
    mapProvider,
    osmAvailable,
    isKakao: mapProvider === "kakao",
    isOSM: mapProvider === "osm",
  };
};

